import React, { Component } from 'react'
import DragDropFunctions from '../../../dragDropFunctions';

export default class RssFeed extends Component {
    constructor(props) {
        super(props)

        this.clickCatcher = this.clickCatcher.bind(this);

    }


    clickCatcher(event) {
        event.preventDefault();
    }

    render() {

        var rssHtml = DragDropFunctions.generateRssContent(this.props.localVariables, this.props.globalVariables)

        var eleProps;
        if (this.props.elementData.props) {
            eleProps = DragDropFunctions.generatePropsForStage(this.props.elementData.props, this.props.globalVariables, "a", this.props.localVariables)
        }



        return <div {...eleProps} dangerouslySetInnerHTML={{ __html: rssHtml }} onClick={this.clickCatcher}></div>

    }
}